import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";

function NtExtrasTosSection(props) {
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/3e9705511f19a42561e30c83f1cb2fc0e029aeba.jpg")}
    >
      <NtSectionTitle style={{ marginTop: 150, fontSize: 28 }}>
        Terms of Service
      </NtSectionTitle>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 300,
  },
});

export default NtExtrasTosSection;
